import { useState } from 'react';
import PropTypes from 'prop-types';
import CustomRadioInput from '../molecules/custom-radio-input.molecule';

const CustomRadioGroup = ({
    label = '',
    error = '',
    helper = '',
    options = [],
    onChange = () => {},
    disabled = false,
    containerStyle,
    inputStyle,
    selectedValue = null,
    id = '',
}) => {
    const [selected, setSelected] = useState(selectedValue);

    const handleChange = (event) => {
        const value = event.target.value;
        setSelected(value);
        onChange(value);
    };


return (
  <div style={{ ...styles.container, ...containerStyle }}>
    {label && <label style={styles.label}>{label}</label>}

    <div style={styles.radioGroup}>
      {options.map((option) => (
        <div key={option.id} style={{ ...styles.radioWrapper, ...(disabled && styles.disabled) }}>
          <CustomRadioInput
            name={label}
            value={option.value}
            label={option.label}
            checked={selected === option.value}
            onChange={handleChange}
            disabled={disabled}
            style={styles.radioInput}
            id={`${id}-option-${option.id}`}
          />
        </div>
      ))}
    </div>

    {helper && <p style={styles.helper}>{helper}</p>}
    {error && <p style={styles.error}>{error}</p>}
  </div>
);

};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'Inter, sans-serif',
    },
    label: {
        color: '#000',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 600,
        fontSize: '16px',

        fontStyle: 'normal',
        lineHeight: '24px',
        alignSelf: 'stretch',

    },
    radioGroup: {
        display: 'flex',
        flexDirection: 'column',
    },
    radioLabel: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    radioInput: {
        cursor: 'pointer',
    },
    optionText: {
        fontSize: 14,
    },
    helper: {
        marginTop: 4,
        fontSize: 12,
        color: '#666',
    },
    error: {
        marginTop: 4,
        fontSize: 12,
        color: 'red',
    },
    disabled: {
        opacity: 0.5,
        cursor: 'not-allowed',
    },
};

CustomRadioGroup.propTypes = {
    label: PropTypes.string,
    error: PropTypes.string,
    helper: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            value: PropTypes.any.isRequired,
        })
    ).isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    containerStyle: PropTypes.object,
    inputStyle: PropTypes.object,
    selectedValue: PropTypes.any,
};

export default CustomRadioGroup;
